
const DataMethodHandler = {

    /**
     * register click event listener
     *
     * @return void
     */
    register() {
        document.addEventListener('click', event => {

            let el = event.target.closest('a[data-method]');
            if (! el) return;

            event.preventDefault();

            this.handle(el);

        }, false);
    },

    /**
     * handle the event
     *
     * @param   {Element}  el
     * @return  {Boolean}
     */
    handle(el) {

        if (el.hasAttribute('disabled')) return false;

        let endpoint = url(el.getAttribute('href'));
        let method = el.dataset.method.toUpperCase();
        let confirmationPromptTitle = el.dataset.confirm;
        let confirmationPromptText = el.dataset.confirmText;

        if (['POST', 'PUT', 'PATCH', 'DELETE'].indexOf(method) === -1) {
            return false;
        }

        if (! confirmationPromptTitle) {
            this.submitRequest(endpoint, method);
            return false;
        }

        this.submitRequestWithConfirmation(endpoint, method, confirmationPromptTitle, confirmationPromptText);
        return false;
    },

    /**
     * submit the request
     *
     * @param   {String}  endpoint
     * @param   {String}  method
     */
    submitRequest(endpoint, method) {
        let form = this.createForm(endpoint, method);
        form.submit();
    },

    /**
     * submit request with cinfirmation popup prompt
     *
     * @param   {String}  endpoint
     * @param   {String}  method
     * @param   {String}  confirmationPromptTitle
     * @param   {String}  confirmationPromptText
     */
    submitRequestWithConfirmation(endpoint, method, confirmationPromptTitle, confirmationPromptText) {

        Swal.fire({
            title: confirmationPromptTitle,
            text: confirmationPromptText,
            icon: 'warning',
            showCancelButton: true
        }).then(result => {
            if (result.dismiss) {
                return false;
            }
            this.submitRequest(endpoint, method);
        });

    },

    /**
     * create helper form to be submitted
     *
     * @param   {String}  endpoint
     * @param   {String}  method
     * @return  {Element}
     */
    createForm(endpoint, method) {

        let form = document.createElement('form');
            form.method = 'POST';
            form.action = endpoint;

        let methodField = document.createElement('input');
            methodField.type = 'hidden';
            methodField.name = '_method';
            methodField.value = method;

        let csrfField = document.createElement('input');
            csrfField.type = 'hidden';
            csrfField.name = '_token';
            csrfField.value = App.csrfToken;

        document.body.appendChild(form);
        form.appendChild(methodField);
        form.appendChild(csrfField);

        return form;

    }
};

DataMethodHandler.register();
